import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import { getClickAndReserveCtaLabelKey } from '../utils/get-click-and-reserve-cta-label-key.js';

const ClickAndReserveButtonContainer = ({ onClick  })=>{
    const { featureConfigs  } = useFeatureToggles();
    const { getLabel  } = useIntl();
    const ctaLabelKey = getClickAndReserveCtaLabelKey(featureConfigs === null || featureConfigs === void 0 ? void 0 : featureConfigs.clickAndReserve);
    const clickAndReserveCtaLabel = ctaLabelKey ? getLabel(ctaLabelKey) : '';
    return /*#__PURE__*/ React.createElement(Button, {
        caption: clickAndReserveCtaLabel,
        variant: "ghost",
        icon: "store",
        color: "primary",
        onClick: onClick,
        className: "click-and-reserve__button"
    });
};

export { ClickAndReserveButtonContainer as default };
//# sourceMappingURL=ClickAndReserveButtonContainer.js.map
